module.exports = {
    Industry: require("./lib/Industry"),
    Category: require("./lib/Category"),
};
